import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch social list data
export const getContractorRegisterList = createAsyncThunk(
  "contractorRegisterList/getContractorRegisterList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/create`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const contractorRegisterSlice = createSlice({
  name: "contractorRegisterList",
  initialState: {
    loading: false,
    contractorRegisterData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContractorRegisterList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContractorRegisterList.fulfilled, (state, action) => {
        state.loading = false;
        state.contractorRegisterData = action.payload;
      })
      .addCase(getContractorRegisterList.rejected, (state, action) => {
        state.loading = false;
        state.contractorRegisterData = action.payload;
        state.error = action.payload;
      });
  },
});

export default contractorRegisterSlice.reducer;
